var $body = $("body");
var $main = $("main");